import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowUpRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <section className="relative min-h-[85vh] bg-ink-900 text-paper grain flex items-center" data-testid="payment-cancel">
      <div className="absolute left-0 bottom-0 w-[40vw] h-[40vw] rounded-full bg-gold/10 blur-[120px]" />
      <div className="relative z-10 mx-auto max-w-2xl px-5 md:px-10 text-center pt-32 pb-20">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <XCircle size={64} className="text-paper/70 mx-auto" />
          <span className="label-mono text-gold block mt-6">Paiement annulé</span>
          <h1 className="font-display text-4xl md:text-6xl font-semibold mt-4 leading-[0.95]">Votre inscription a été interrompue.</h1>
          <p className="text-paper/60 mt-6 text-lg">Aucun montant n'a été débité. Vous pouvez reprendre votre inscription à tout moment.</p>
          <div className="flex flex-wrap gap-3 justify-center mt-10">
            <Link to="/formation" data-testid="cancel-back-formation" className="inline-flex items-center gap-2 rounded-full bg-gold text-ink px-7 py-4 label-mono hover:bg-paper transition-colors">
              Reprendre l'inscription <ArrowUpRight size={15} />
            </Link>
            <Link to="/" className="inline-flex items-center gap-2 rounded-full border border-paper/30 px-7 py-4 label-mono hover:bg-paper hover:text-ink transition-colors">
              Retour à l'accueil
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
